import { Injectable } from '@angular/core';
import { HttpService } from '../services/http.service';
import { SnEnvService } from '@insight/serenity-env';
import { Observable } from 'rxjs';
import { IgnoreProduct } from '../shared/classes/models/IgnoreProduct';
import { ClientBillingIgnoreProductService } from '../shared/api/services';

@Injectable({
  providedIn: 'root'
})
export class AggregationDataService
{
  // #region Constructors
  constructor(private _httpService: HttpService,
              private _envService: SnEnvService,
              private _ingoreProductService: ClientBillingIgnoreProductService) {}
  // #endregion

  // --------------------------------------------------

  // #region Methods
  resolveAsComplete(aggregationResultId: string): Observable<any> {
    const url = this._envService.get('api_url') + "aggregationresult/complete/" + aggregationResultId;
    return this._httpService.post<any>(url, {});
  }

  resolveAsRerun(aggregationResultId: string): Observable<any> {
    const url = this._envService.get('api_url') + "aggregationresult/rerun/" + aggregationResultId;
    return this._httpService.post<any>(url, {});
  }

  bulkIgnoreProduct(bulkIngest:IgnoreProduct[], bulkDelete:string[]): Observable<any>{
    let body: ClientBillingIgnoreProductService.BulkParams = {
      dto: { bulkIngest: bulkIngest, bulkDelete: bulkDelete } 
    };
    return this._ingoreProductService.Bulk(body)
  }
  // #endregion
}
